import React, { useState } from 'react';
import { ChevronDown, Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useBusiness } from '../context/BusinessContext';
import AddBusinessModal from './AddBusinessModal';

export default function BusinessSelector() {
  const { businesses, currentBusiness, switchBusiness } = useBusiness();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);

  const handleBusinessSwitch = (businessId) => {
    switchBusiness(businessId);
    navigate(`/dashboard/${businessId}`);
  };
  return (
    <>
      <div className="relative inline-block">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center gap-2 px-3 py-2 bg-white/10 hover:bg-white/20 rounded-lg text-white text-sm font-medium transition-colors"
        >
          <span className="text-green-400 text-lg">📍</span>
          <span className="max-w-[150px] truncate">{currentBusiness?.name || 'Select Business'}</span>
          <ChevronDown size={16} />
        </button>

        {isOpen && (
          <div className="absolute top-full left-0 mt-2 w-48 bg-[#0a0a0a] border border-white/10 rounded-lg shadow-lg z-50">
            <div className="max-h-[300px] overflow-y-auto">
              {businesses.map(business => (
                <button
                  key={business.id}
                  onClick={() => {
                    handleBusinessSwitch(business.id);
                    setIsOpen(false);
                  }}
                  className={`w-full text-left px-4 py-2 hover:bg-white/10 transition-colors ${
                    currentBusiness?.id === business.id ? 'bg-green-500/20 text-green-400' : 'text-white/70'
                  }`}
                >
                  <p className="font-medium text-sm">{business.name}</p>
                  <p className="text-xs text-white/40">{business.location || 'No location'}</p>
                </button>
              ))}
            </div>

            <button
              onClick={() => {
                setShowAddModal(true);
                setIsOpen(false);
              }}
              className="w-full border-t border-white/10 px-4 py-2 hover:bg-white/10 text-white/70 hover:text-white flex items-center gap-2 text-sm transition-colors"
            >
              <Plus size={16} />
              Add Business
            </button>
          </div>
        )}
      </div>

      {showAddModal && <AddBusinessModal onClose={() => setShowAddModal(false)} />}
    </>
  );
}
